import { and } from 'ramda';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Text } from '../../../../../components/common';
import styles from './FilesViewerFooter.scss';
import { IOuter } from './FilesViewerFooter.types';

export const FilesViewerFooter: FC<IOuter> = ({
  selectedItemsCount,
  onImportButtonClick,
  isButtonDisabled,
  message,
}) => {
  const isMessageVisible = and(message, isButtonDisabled);

  return (
    <div className={styles.wrapper}>
      <span data-hook="files-importer-footer-notice">
        {isMessageVisible && (
          <Text weight="thin" size="small" secondary light>
            {message}
          </Text>
        )}
      </span>

      <Button
        size="small"
        disabled={isButtonDisabled}
        onClick={onImportButtonClick}
        dataHook="files-importer-import-button"
      >
        {isButtonDisabled ? (
          <FormattedMessage id="files-importer.new-select-files-button.disabled" />
        ) : (
          <FormattedMessage
            id="files-importer.new-select-files-button.enabled"
            values={{ itemsNumber: selectedItemsCount }}
          />
        )}
      </Button>
    </div>
  );
};
